module.exports = __webpack_public_path__ + "static/media/view2.f6311202.jpg";